import { render, staticRenderFns } from "./guideCard.vue?vue&type=template&id=45d85238&scoped=true"
import script from "./guideCard.vue?vue&type=script&lang=js"
export * from "./guideCard.vue?vue&type=script&lang=js"
import style0 from "./guideCard.vue?vue&type=style&index=0&id=45d85238&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45d85238",
  null
  
)

export default component.exports